import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";
import { Button } from "../components/ui/button";

export default function PaymentCancel() {
  return (
    <div data-testid="payment-cancel-page" className="min-h-[calc(100vh-4rem)] flex items-center justify-center px-6">
      <div className="text-center max-w-md">
        <XCircle className="w-12 h-12 text-muted-foreground mx-auto" />
        <h1 className="font-display text-3xl mt-6">Checkout cancelled</h1>
        <p className="text-muted-foreground mt-3 text-sm">No charge was made. You can pick a plan anytime from your billing page.</p>
        <Link to="/dashboard">
          <Button data-testid="back-to-dashboard-btn" variant="outline" className="mt-8 rounded-full">Back to dashboard</Button>
        </Link>
      </div>
    </div>
  );
}
